import { pca, loginRequest } from './msalConfig'

export function login() {
  return pca.loginRedirect(loginRequest)
}

export function logout() {
  return pca.logoutRedirect()
}
